import { render, staticRenderFns } from "./Thanks.vue?vue&type=template&id=e7d63b5c&"
import script from "./Thanks.vue?vue&type=script&lang=js&"
export * from "./Thanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports